import { type IGeoTagsMap } from '@/microfrontends/filters/shared/types/geoTags';

export const GEO_TAGS_MAP_DEFAULT: IGeoTagsMap = {
  developer: [],
  distance: [],
  district: [],
  highway: [],
  house: [],
  location: [],
  newobject: [],
  polygon: [],
  railway: [],
  regionalDistrict: [],
  street: [],
  underground: [],
};
